import enquire from 'enquire.js';
import Mmenu from 'mmenu-js';

const navbar = {
  attach(context) {
        // DESKTOP NAVBAR
        enquire.register("screen and (min-width: 768px)", {
			match: function() {
				const navbarEl = context.querySelector('#navbar') || document.querySelector('#navbar');
                if (!navbarEl) return;
                const menuItems = navbarEl.querySelectorAll('.menu-item');

                // Pour éviter d'attacher plusieurs fois les mêmes événements
                menuItems.forEach(item => {
                    if (item.dataset.hoverBound === 'true') {
                        return; // évite doublons d'écouteurs
                    }
                    item.dataset.hoverBound = 'true';

                    item.addEventListener('mouseenter', () => {
                        item.classList.add('active');
                        const dropdown = item.querySelector('.navbar-deploy');
                        if (dropdown) {
                        dropdown.style.display = 'block';
                        }
                    });

                    item.addEventListener('mouseleave', () => {
                        item.classList.remove('active');
                        const dropdown = item.querySelector('.navbar-deploy');
                        if (dropdown) {
                        dropdown.style.display = 'none';
                        }
                    });
                });
			},
			unmatch : function() {
				
			}
		});
		// MM MOBILENAV
		enquire.register("screen and (max-width: 767px)", {
			match: function() {
				const menuElement = context.querySelector('#navbar-mobile') || document.querySelector('#navbar-mobile');
                if (menuElement && !menuElement.dataset.mmenuInitialized) {
                    const mmenu = new Mmenu(menuElement, {
                        "counters": {
                            "add": true
                        },
                        navbars: [
                            {
                                position: 'top',
                                content: ['prev', 'title', 'close']
                            }
                        ]
                    }, {
                        // configuration
                        offCanvas: {
                            clone: false
                        }
                    });

                    // Open via toggle button
                    const toggle = document.querySelector('.navbar-toggler');
                    if (toggle) {
                        toggle.addEventListener('click', (e) => {
                        e.preventDefault();
                        mmenu.API.open();
                        });
                    }

                    menuElement.dataset.mmenuInitialized = 'true';
                }
			},
			unmatch : function() {
                /*
                const menuElement = context.querySelector('#navbar');
                if (menuElement && menuElement.dataset.mmenuInitialized === 'true') {
                    document.querySelector('.mm-menu')?.remove();
                    document.querySelector('.mm-page')?.remove();
                    document.body.classList.remove('mm-wrapper--opened');
                    delete menuElement.dataset.mmenuInitialized;
                }
                */
			}
		});
    }
};

// On expose explicitement le behavior à Drupal pour s'assurer qu'il est bien pris en compte
if (typeof Drupal !== 'undefined') {
  Drupal.behaviors.navbar = navbar;
}

export default navbar;